import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private readonly oAuthService: OAuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        try {
            if (this.oAuthService.hasValidAccessToken()) {
                const token = this.oAuthService.getAccessToken();
                const request = req.clone({
                    setHeaders: { Authorization: `Bearer ${token}` }
                });

                return next.handle(request);
            } else {
                return next.handle(req.clone());
            }
        } catch (e) {
            console.error('Interceptor error: ', req?.url);
            return of(null);
        }
    }

}
